var fails = require('../internals/fails');
module.exports = !fails(function () {
  return Object.isExtensible(Object.preventExtensions({}));
});